module.exports = __webpack_public_path__ + "media/images/proposal/top/reason4-9b12d2dfe1a74b83478d3975527f4d1f.jpg";